import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { Close as IconClose } from "@mui/icons-material";

import ReceiptEdit from "../containers/Receipt/Edit";
import { PaperComponentDraggable } from "./common/PaperComponentDraggable";

// Mantenimiento del comprobante dentro de un dialogo.
//
// Se usa desde el detalle de la atencion, donde el comprobante se registra sin
// salir de la pantalla, y desde la navegabilidad de los periodos de terapia,
// donde el comprobante del periodo se arma con la tarifa y su descuento. Al
// guardar se avisa el identificador para que la pantalla que abrio el dialogo
// lo deje en la fila correspondiente.
const ComprobanteMantenimientoDialogo = ({ open, onClose, onSaved, idComprobante = 0, prefill, initialDetails, detalleSoloLectura = false }) => {
    // Se reinicia al abrir: cada alta parte de un comprobante en blanco.
    const [clave, setClave] = useState(0);

    useEffect(() => {
        if (open) setClave((previo) => previo + 1);
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperComponent={PaperComponentDraggable}>
            <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                <Grid alignItems="center" container spacing={1}>
                    <Grid item xs={10} sm={10}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {(parseInt(idComprobante) > 0 ? "Comprobante" : "Registrar Comprobante")}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} display="flex" justifyContent="flex-end">
                        <IconButton aria-label="cerrar" size="small" onClick={onClose}>
                            <IconClose fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>

            <DialogContent dividers>
                {/* La clave cambia en cada apertura para que el formulario se
                    reinicie y no herede el comprobante anterior. */}
                <ReceiptEdit
                    key={clave}
                    idComprobante={idComprobante}
                    enDialogo={true}
                    prefill={prefill}
                    initialDetails={initialDetails}
                    detalleSoloLectura={detalleSoloLectura}
                    onSaved={(idGuardado) => {
                        if (onSaved) onSaved(idGuardado);
                    }}
                />
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>{"Cerrar"}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ComprobanteMantenimientoDialogo;